/*
  Clipz-it - Cards produits dynamiques dans les articles de blog.
  Met a jour le prix et le statut de stock depuis /products/{handle}.js
  Si l'appel echoue, le prix ecrit en dur dans le HTML reste affiche.
  Aucune donnee promotionnelle n'est injectee : ni prix barre, ni badge, ni note.
*/
(function () {
  'use strict';

  var CARDS_SELECTOR = '.cz-article-product-card[data-product-handle]';

  var STOCK = {
    fr: ['En stock', 'Rupture temporaire'],
    bg: ['В наличност', 'Временно изчерпан'],
    cs: ['Skladem', 'Dočasně vyprodáno'],
    da: ['På lager', 'Midlertidigt udsolgt'],
    de: ['Auf Lager', 'Vorübergehend ausverkauft'],
    el: ['Διαθέσιμο', 'Προσωρινά εξαντλημένο'],
    en: ['In stock', 'Temporarily out of stock'],
    es: ['En stock', 'Agotado temporalmente'],
    et: ['Laos', 'Ajutiselt otsas'],
    fi: ['Varastossa', 'Tilapäisesti loppu'],
    hr: ['Na zalihi', 'Privremeno nedostupno'],
    hu: ['Raktáron', 'Átmenetileg elfogyott'],
    it: ['Disponibile', 'Temporaneamente esaurito'],
    lt: ['Yra sandėlyje', 'Laikinai neturime'],
    nl: ['Op voorraad', 'Tijdelijk uitverkocht'],
    pl: ['Dostępny', 'Chwilowo niedostępny'],
    pt: ['Em stock', 'Temporariamente esgotado'],
    ro: ['În stoc', 'Epuizat temporar'],
    sk: ['Skladom', 'Dočasne vypredané'],
    sv: ['I lager', 'Tillfälligt slut']
  };

  var getLocale = function () {
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'fr';
    return String(l);
  };

  var stockLabels = function () {
    var key = getLocale().slice(0, 2).toLowerCase();
    return STOCK[key] || STOCK.en;
  };

  var routesRoot = function () {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  };

  var formatPrice = function (cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var amount = cents / 100;
    var whole = Math.round(cents) % 100 === 0;
    var opts = { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' };
    if (whole) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    try {
      return new Intl.NumberFormat(getLocale(), opts).format(amount);
    } catch (e) {
      try {
        return new Intl.NumberFormat('fr-FR', opts).format(amount);
      } catch (e2) {
        return (whole ? String(amount) : amount.toFixed(2)) + ' ' + currency;
      }
    }
  };

  function updateCard(card) {
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    fetch(routesRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        if (!product) return;

        var priceEl = card.querySelector('[data-price]');
        if (priceEl && typeof product.price === 'number') {
          priceEl.textContent = formatPrice(product.price);
        }

        var stockEl = card.querySelector('[data-stock-status]');
        if (stockEl) {
          if (product.available === false) {
            stockEl.textContent = stockLabels()[1];
            stockEl.classList.add('cz-stock-empty');
            stockEl.classList.remove('cz-stock-available');
          } else {
            stockEl.textContent = stockLabels()[0];
            stockEl.classList.add('cz-stock-available');
            stockEl.classList.remove('cz-stock-empty');
          }
        }

        if (card.hasAttribute('data-sync-image')) {
          var imgEl = card.querySelector('img');
          if (imgEl && product.featured_image) {
            imgEl.src = product.featured_image;
          }
        }
      })
      .catch(function () {
        /* Silencieux : le prix et le stock ecrits en dur restent visibles. */
      });
  }

  function init() {
    var cards = document.querySelectorAll(CARDS_SELECTOR);
    if (!cards.length) return;
    Array.prototype.forEach.call(cards, updateCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
